import { render, staticRenderFns } from "./TileIcon.vue?vue&type=template&id=06a9dfcc&"
import script from "./TileIcon.vue?vue&type=script&lang=ts&"
export * from "./TileIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TileIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports